import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import StickyNavBar from './StickyNavBar';
import BottomNavigation from './BottomNavigation';
import SwipeNavigation from './SwipeNavigation';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export default function Layout() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen bg-black">
      <Sidebar />

      <main className="flex-1 min-w-0">
        <div className="relative min-h-screen pb-20 md:pb-0">
          {/* Background pattern with fox - Double couche avec glow */}
          {/* Couche 1 : Renards normaux */}
          <div 
            className="fixed inset-0 pointer-events-none"
            style={{
              backgroundImage: `url('https://customer-assets.emergentagent.com/job_foodtech-finplan/artifacts/ye5d9g73_image.png')`,
              backgroundSize: '180px',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              opacity: 0.12
            }}
          />
          {/* Couche 2 : Renards avec glow lime néon */}
          <div 
            className="fixed inset-0 pointer-events-none"
            style={{
              backgroundImage: `url('https://customer-assets.emergentagent.com/job_foodtech-finplan/artifacts/ye5d9g73_image.png')`,
              backgroundSize: '180px',
              backgroundRepeat: 'repeat',
              backgroundPosition: 'center',
              opacity: 0.08,
              filter: 'drop-shadow(0 0 8px rgba(168, 213, 48, 0.6)) drop-shadow(0 0 12px rgba(168, 213, 48, 0.4))'
            }}
          />
          
          {/* Sticky Navigation Bar */}
          <StickyNavBar />
          
          {/* Content with swipe */}
          <SwipeNavigation>
            <div className="relative z-10">
              <Outlet />
            </div>
          </SwipeNavigation>
          
          {/* Bottom Navigation - Mobile only */}
          <BottomNavigation />
        </div>
      </main>
    </div>
  );
}
